import { ProgramBundleInfoHeader } from "@modules/programBundle/components/programBundleInfoHeader"
import { ProgramBundleEntity } from "@modules/programBundle/entities/programBundleEntity"
import { ProgramInfoHeader } from "@modules/programs/components/programInfoHeader"
import { Program } from "@modules/programs/programTypes"
import { EmbeddedCheckout, EmbeddedCheckoutProvider } from "@stripe/react-stripe-js"
import { Stripe } from "@stripe/stripe-js"

export const CheckoutContainer: React.FC<{
  stripePromise: Stripe
  clientSecret: string
  program?: Program | ProgramBundleEntity
}> = ({ clientSecret, stripePromise, program }) => {
  return (
    <EmbeddedCheckoutProvider stripe={stripePromise} options={{ clientSecret }}>
      <div className="flex flex-column flew-grow-1">
        {program &&
          (program instanceof ProgramBundleEntity ? (
            <ProgramBundleInfoHeader programBundle={program} editionAllowed={false} />
          ) : (
            <ProgramInfoHeader program={program} />
          ))}
        <div className={`pb-6 ${program instanceof ProgramBundleEntity ? "mt-1" : "mt-8"}`}>
          <EmbeddedCheckout />
        </div>
      </div>
    </EmbeddedCheckoutProvider>
  )
}
